module.exports = __webpack_public_path__ + "static/ram-e7aab7b2c0e1d87f11f0e99eafcd539d.png";